<template>
    <div class="vrm-theme-nav-bottom">
        <div v-if="isSummerThemeEnabled && isLightTheme" class="vrm-theme-nav-bottom--sticky">
            <img
                class="show-in-desktop-umbrella"
                src="/img/themes/summer/umbrella.svg"
                alt="Summer illustration of a ball"
            />
            <img
                class="hide-in-desktop-umbrella"
                src="/img/themes/summer/umbrella-mobile.svg"
                alt="Summer illustration of a ball"
            />
        </div>
        <div v-else-if="isChristmasThemeEnabled">
            <img src="/img/themes/christmas/snowman-small.svg" alt="Christmas illustration" />
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

import { ngInject } from '@/vue/decorators/angular-interop';

@Component({
    components: {},
})
@AngularDirective('vrm-theme-nav-bottom')
export default class VrmThemeNavBottom extends Vue {
    @ngInject()
    AppearanceService;

    get isLightTheme() {
        return !this.AppearanceService.isDarkModeActive();
    }

    get isSummerThemeEnabled() {
        return this.AppearanceService.isSummerThemeActive();
    }

    get isChristmasThemeEnabled() {
        return this.AppearanceService.isChristmasThemeActive();
    }
}
</script>
